import { render } from "./DialogCustomInputs.vue?vue&type=template&id=81c3bed6"
import script from "./DialogCustomInputs.vue?vue&type=script&lang=js"
export * from "./DialogCustomInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__